import { useCookies } from 'react-cookie'
import { COOKIE_LIST } from '../../../modules/vars'
export default function useIsAdminLogin() {
  const [cookies, setCookies] = useCookies([COOKIE_LIST.IS_ADMIN_LOGIN])
  return cookies.is_admin_login === 'true'
}
